<!--
example
<RadioGroup v-model="a" data=[
  {text:'选项1',value:'1',disabled:true}
]></RadioGroup>
-->
<template>
	<div class="radio-group">
		<!-- <Radio v-for="(item,index) in data" :key="index" v-model="groupValue" :value="item.value"
			   :disabled="item.disabled">{{item.text}}
		</Radio> -->
		<div v-for="(item, index) in data" :key="index" style="width: 100%; height: 1rem; margin-bottom: 2rem">
			<Radio
				class="mr1x mb1x"
				:class="{ disable: item.disabled }"
				style="float: left; width: max-conetnt"
				v-model="groupValue"
				:label="item.value"
				:text="item.text"
			></Radio>
			<component v-if="item.help" :class="{ disable: item.disabled }" :is="currentViewHelp" :code="'myWorkOrder'" />
		</div>
	</div>
</template>
<script>
import Help from "@/components/common/Help";
export default {
	name: "radioGroup",
	data() {
		return {
			groupValue: this.value,
			currentViewHelp: Help,
		};
	},
	watch: {
		groupValue(v) {
			this.$emit("input", v);
			this.change ? this.change(v) : "";
		},
		value(v) {
			this.groupValue = v;
		},
	},
	props: {
		value: {},
		modelValue: {},
		data: Array,
		change: Function,
	},
	components: { Help },
	methods: {},
	mounted() {},
	computed: {},
};
</script>
<style lang="scss" scoped>
.dsP {
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/RadioGroup.vue